import { array, InferType, object, string } from 'yup';

export const selectedColumnsSettingScheme = object({
  name: string<'selectedColumnsSetting'>().required(),
  value: array().of(string().required()).json().nullable(),
});

export type SelectedColumnsSetting = InferType<
  typeof selectedColumnsSettingScheme
>;
